import * as React from 'react'
export const TwitterIcon = () => {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.00228 0H16.9977C18.6558 0 20 1.34417 20 3.00228V16.9977C20 18.6558 18.6558 20 16.9977 20H3.00228C1.34417 20 0 18.6558 0 16.9977V3.00228C0 1.34417 1.34417 0 3.00228 0ZM14.5734 15.3498H13.3539L13.3526 15.3485L5.39568 4.57706H6.7038L14.5734 15.3498ZM16.3262 3.2859H14.126H14.1247L10.5003 7.57674L7.36633 3.2859H2.82639L8.25189 10.6286L3.11071 16.7127H5.31221L9.2796 12.0189L12.7475 16.7127H17.174L11.5202 8.97354L16.3262 3.2859Z'
        fill='current'
      />
    </svg>
  )
}
